import { Landmark } from 'lucide-react';

// lucide-react ya no incluye logos de marcas (LinkedIn/Instagram/Facebook);
// se usan íconos SVG propios, minimalistas, en su lugar.
function LinkedInIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.1 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8.5h4V23h-4V8.5zM8.5 8.5h3.83v1.98h.05c.53-1 1.83-2.06 3.77-2.06 4.03 0 4.78 2.65 4.78 6.1V23h-4v-6.6c0-1.57-.03-3.6-2.2-3.6-2.2 0-2.53 1.72-2.53 3.49V23h-4V8.5z" />
    </svg>
  );
}
function InstagramIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}
function FacebookIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.5-3.89 3.78-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z" />
    </svg>
  );
}

const LINKS = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Planes', href: '#planes' },
  { label: 'Soporte', href: 'mailto:concilia@conciliabanco.com' },
  { label: 'Contacto', href: '/contacto' },
  { label: 'Términos y condiciones', href: '/terminos' },
  { label: 'Política de privacidad', href: '/privacidad' },
];

export default function Footer() {
  return (
    <footer className="bg-navy-950 border-t border-white/10 pt-14 pb-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="max-w-xs">
            <div className="flex items-center gap-2 font-bold text-white text-lg">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-brand-green text-white">
                <Landmark size={18} />
              </span>
              Conciliabanco
            </div>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">
              Software inteligente de conciliación bancaria.
            </p>
            <div className="flex gap-3 mt-5">
              {[LinkedInIcon, InstagramIcon, FacebookIcon].map((Icon, i) => (
                <a
                  key={i}
                  href="#inicio"
                  className="flex items-center justify-center w-9 h-9 rounded-lg bg-white/5 text-slate-300 hover:bg-white/10 hover:text-white transition-colors"
                >
                  <Icon width={16} height={16} />
                </a>
              ))}
            </div>
          </div>

          <nav className="grid grid-cols-2 sm:grid-cols-3 gap-x-10 gap-y-3">
            {LINKS.map((l) => (
              <a key={l.label} href={l.href} className="text-sm text-slate-400 hover:text-white transition-colors">
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} Conciliabanco. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
